import { render, staticRenderFns } from "./pintuanOrderDetail.vue?vue&type=template&id=80440bdc&scoped=true"
import script from "./pintuanOrderDetail.vue?vue&type=script&lang=js"
export * from "./pintuanOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./pintuanOrderDetail.vue?vue&type=style&index=0&id=80440bdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80440bdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80440bdc')) {
      api.createRecord('80440bdc', component.options)
    } else {
      api.reload('80440bdc', component.options)
    }
    module.hot.accept("./pintuanOrderDetail.vue?vue&type=template&id=80440bdc&scoped=true", function () {
      api.rerender('80440bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/pintuanOrder/pintuanOrderDetail.vue"
export default component.exports